export default __webpack_public_path__ + "static/media/DELETE_BLACK.e562cec8.svg";